var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.field.type == 'search')?_c('div',{staticClass:"text"},[_c('search-component',{attrs:{"model_name":_vm.modelNameFromRelationKey(_vm.filter)},on:{"setSelected":_vm.setFilters,"clearSelected":_vm.clear_selected}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }